module.exports = __webpack_public_path__ + "public/SideMenuIcons/homePageSetting.svg?acd03322";